import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import { useIntl } from 'react-intl';
import { Button, Icon } from '@marketplace/ui-elements';

import { STRING_DESCRIPTION_LENGTH } from '../../../constants';
import { getEllipsisText } from '../../../utils';
import {
  EmbedModeContext,
  useEmbedMode,
  EMApplicationStatuses,
  TEMApplication,
} from '../../../../features';

import { ApplicationsItemType } from '@marketplace/api';

import AddedIcon from '../../../../assets/svg/added.svg';

export const ApplicationCard = (props: ApplicationsItemType) => {
  const { formatMessage } = useIntl();
  const { isEmbeddedMode, embedSource } = useEmbedMode();
  const { getApplicationById, changeApplication } =
    useContext(EmbedModeContext);

  const application: TEMApplication | null =
    getApplicationById && getApplicationById(props.id);

  const applicationStatus = application
    ? application.status
    : EMApplicationStatuses.UNINSTALLED;
  const showedAddButton = ![
    EMApplicationStatuses.INSTALLED,
    EMApplicationStatuses.UNINSTALL,
  ].includes(applicationStatus);
  const showedRemoveButton = [
    EMApplicationStatuses.INSTALLED,
    EMApplicationStatuses.UNINSTALL,
  ].includes(applicationStatus);

  const isBackendApp = props?.application_launch_type?.name == 'BACKEND_SERVICE' ? true : false;

  const handleAddApplication = () => {
    const transformedData: TEMApplication | undefined =
      changeApplication?.transformAPIToEMData({
        ...props,
        status: EMApplicationStatuses.INSTALL,
      });

    transformedData && changeApplication && changeApplication(transformedData);
  };

  const handleRemoveApplication = () => {
    const transformedData: TEMApplication | undefined =
      changeApplication?.transformAPIToEMData({
        ...props,
        status: EMApplicationStatuses.UNINSTALL,
      });
    transformedData && changeApplication && changeApplication(transformedData);
  };

  return (
    <div
      className={
        isEmbeddedMode
          ? 'all-apps-list__item ehr-design'
          : 'all-apps-list__item'
      }
    >
      <div className="image-block">
        <div className="image-block__img">
          {props.icon && props.icon !== '' && <img src={props.icon} alt="" />}
        </div>
      </div>
      <div className="content-block">
        <div className="content-block__title">{props.name}</div>
        <div className="content-block__by">by {props.company_name}</div>
        <div className="content-block__text">
          {getEllipsisText(props.short_description, STRING_DESCRIPTION_LENGTH)}
        </div>

        <div className="content-block__link">
          {showedAddButton && isEmbeddedMode && embedSource=='ehr' && !isBackendApp && (
            <Button
              onClick={handleAddApplication}
              rootClassName="application-list-add-app-button"
              loading={applicationStatus === EMApplicationStatuses.INSTALL}
            >
              {formatMessage({ id: 'app_gallery_add_app' })}
            </Button>
          )}
          {showedRemoveButton && isEmbeddedMode && embedSource=='ehr' && !isBackendApp && (
            <div className="added-status">
              <img src={AddedIcon} alt="" />
              <span>{formatMessage({ id: 'app_gallery_added' })}</span>
              <Button
                onClick={handleRemoveApplication}
                icon="pi pi-trash"
                rootClassName={'removeBtn'}
                loading={applicationStatus === EMApplicationStatuses.UNINSTALL}
              />
            </div>
          )}
          <Link to={`/app-gallery/${props.id}`}>
            {formatMessage({ id: 'app_gallery_more_information' })}
          </Link>
        </div>
      </div>
    </div>
  );
};
